import { TXTWCL_No_consecutive_spaces_are_allo_ELL } from '../translations';
import type { Error } from '../types';
import { NO_CONSECUTIVE_SPACES } from '../utils/regex';

export const noConsecutiveSpaces = (value: string): Error => ({
  valid: !!value && !NO_CONSECUTIVE_SPACES.test(value),
  message: TXTWCL_No_consecutive_spaces_are_allo_ELL
});
